<div class="mt-6" data-testid="rfd-schedule-calendar">
  <div class="mb-3 flex flex-wrap items-center justify-between gap-2">
    <h4 class="text-base font-semibold">
      {{ 'project.steps.rfd.invitationList.calendar.title' | transloco }}
    </h4>
    <div class="flex items-center gap-2">
      <p-button
        icon="pi pi-chevron-left"
        severity="secondary"
        size="small"
        [text]="true"
        [pTooltip]="'project.steps.rfd.invitationList.calendar.previousMonth' | transloco"
        [ariaLabel]="'project.steps.rfd.invitationList.calendar.previousMonth' | transloco"
        (onClick)="showPreviousMonth()"
        data-testid="rfd-calendar-previous"
      />
      <span class="min-w-40 text-center font-medium" data-testid="rfd-calendar-month">
        {{ monthTitle() }}
      </span>
      <p-button
        icon="pi pi-chevron-right"
        severity="secondary"
        size="small"
        [text]="true"
        [pTooltip]="'project.steps.rfd.invitationList.calendar.nextMonth' | transloco"
        [ariaLabel]="'project.steps.rfd.invitationList.calendar.nextMonth' | transloco"
        (onClick)="showNextMonth()"
        data-testid="rfd-calendar-next"
      />
      <p-button
        severity="secondary"
        size="small"
        [outlined]="true"
        [label]="'project.steps.rfd.invitationList.calendar.today' | transloco"
        (onClick)="showCurrentMonth()"
        data-testid="rfd-calendar-today"
      />
    </div>
  </div>

  <div class="border-surface overflow-hidden rounded-border border">
    <div class="bg-surface-100 dark:bg-surface-800 grid grid-cols-7">
      @for (label of weekdayLabels(); track $index) {
        <div class="text-muted-color px-2 py-1 text-xs font-semibold uppercase">{{ label }}</div>
      }
    </div>
    @for (week of weeks(); track $index) {
      <div class="grid grid-cols-7">
        @for (day of week; track day.date.getTime()) {
          <div
            class="border-surface min-h-24 border-t border-l p-1 first:border-l-0"
            [class.opacity-50]="!day.inVisibleMonth"
            data-testid="rfd-calendar-day"
          >
            <div
              class="mb-1 text-xs"
              [class.text-primary]="day.isToday"
              [class.font-bold]="day.isToday"
            >
              {{ day.date.getDate() }}
            </div>
            @for (appointment of day.appointments; track appointment.participatingToolId) {
              <div
                class="bg-surface-50 dark:bg-surface-900 mb-1 rounded border-l-4 px-1 py-0.5 text-xs"
                [style.borderLeftColor]="resolveStatusColor(appointment)"
                [pTooltip]="appointment.toolName ?? appointment.providerName"
                data-testid="rfd-calendar-appointment"
              >
                <div class="flex items-center gap-1">
                  <span class="font-semibold">{{ formatTime(appointment.start) }}</span>
                  @if (resolvePlaceIcon(appointment.place); as placeIcon) {
                    <i
                      [class]="placeIcon + ' text-xs'"
                      [pTooltip]="resolvePlaceLabelKey(appointment.place) | transloco"
                    ></i>
                  }
                </div>
                <div class="truncate">{{ appointment.providerName }}</div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>

  <div class="mt-3 flex flex-wrap items-center justify-between gap-2">
    <app-color-legend [entries]="legendEntries" />
    @if (!hasAppointments()) {
      <span class="text-muted-color text-sm" data-testid="rfd-calendar-empty">
        {{ 'project.steps.rfd.invitationList.calendar.empty' | transloco }}
      </span>
    }
  </div>
</div>
